const couponRedemptionRoutes = [
    {
        path: '/coupon-redemption',
        name: 'couponRedemption',
        component: () => import('@/modules/coupon_redemption/list/List.vue'),
        meta: {
            resource: 'coupons',
            action: 'view_redeemed',
            layout: 'default',
            auth: true,
            title: 'Coupon Redemption',
            breadcrumbs: [{ title: 'Coupon Redemption', routeName: 'couponRedemption' }]
        }
    }
]
export default couponRedemptionRoutes
